import React, { useCallback, useEffect, useState } from "react";
import styles from "./ProjectsFeedPage.module.scss";
import ProjectsFilterSection from "../../components/ProjectsFilterSection/ProjectsFilterSection";
import ProjectsCardComponent from "../../components/ProjectsCardComponent/ProjectsCardComponent";
import { useSelector, useDispatch } from "react-redux";
import { getProjects } from "../../reducer/projectsSlice";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/UI/Button/Button";
import PlusIconSVG from "../../components/SVGComponents/PlusIconSVG";
// import SpinnerLoader from "../../components/UI/SpinnerLoader/SpinnerLoader";
import CustomSortDropdown from "../../components/CustomSortDropdown/CustomSortDropdown";
import InfiniteScroll from "react-infinite-scroll-component";
import ProjectCardSkeleton from "components/ProjectsCardComponent/ProjectCardSkeleton";
import InfiniteEndMessage from "components/InfiniteEndMessage/InfiniteEndMessage";
// import { getActivePlanOfUser } from "../../reducer/paymentSlice";
// import Pagination from "../../components/Pagination/Pagination";
import noApplicationsImg from "../../images/errorImages/noApplications.png";

const ProjectsFeedPage = () => {
  const { projects, totalProjects } = useSelector((state) => state.projects);
  const { userProfile } = useSelector((state) => state.userProfile);

  const dispatch = useDispatch();
  const locationUse = useLocation();
  const navigate = useNavigate();

  const userType =
    window?.atob(localStorage.getItem("userType")) || userProfile?.userType;

  const params = new URLSearchParams(locationUse.search);
  const search = params.get("search");
  const industry = params.get("industry");
  const categoryId = params.get("categoryId");
  const skills = params.get("skills");
  const location = params.get("location");

  // PAGINATION STATES
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);

  const [sortBy, setSortBy] = useState("Latest");
  const [hasMore, setHasMore] = useState(true);
  const itemsPerPage = 10;

  const updateSortBy = useCallback((option) => {
    setPage(1);
    setSortBy(option);
  }, []);

  const fetchProjects = useCallback(
    async (reset = false) => {
      if (reset) {
        setHasMore(true);
      }

      setIsLoading(true);

      const currentPage = reset ? 1 : page;

      const res = await dispatch(
        getProjects({
          pageNo: currentPage,
          perPage: itemsPerPage,
          sortBy: sortBy.toUpperCase(),
          search,
          industry,
          categoryId,
          location,
          skills,
        })
      );

      if (res?.payload?.results?.length < itemsPerPage) {
        setHasMore(false);
      } else if (!reset) {
        setPage((prev) => prev + 1);
      }

      setIsLoading(false);
    },
    [page, sortBy, search, industry, categoryId, skills, location, dispatch]
  );

  useEffect(() => {
    fetchProjects(false);
  }, [sortBy]);

  return (
    <>
      <section className={styles.projects_main}>
        <section className={styles.projects_browse_roles}>
          <div className={styles.left_title}>
            {/* <p className={styles.projects_browse_roles_title}>
              {totalProjects} {projects?.length > 1 ? "Projects" : "Project"}{" "}
              {userProfile?.userType === "CREATOR" ? "available" : "created"}{" "}
            </p>  */}

            {/* <div className={styles.projects_browse_roles_description} /> */}
            {/* {userProfile?.userType === "CREATOR" ? (
              <p className={styles.projects_browse_roles_description}>
                Choose from a wide range of projects to gain hands-on experience
                and grow your skill
              </p>
            ) : (
              <p className={styles.projects_browse_roles_description}>
                Turning Ideas Into Interactive Experiences
              </p>
            )} */}
          </div>

          <div className={styles.right_sort_create}>
            {userType === "CREATOR" ? (
              <div className={styles.projects_sort_by}>
                <CustomSortDropdown
                  value={sortBy}
                  setValue={updateSortBy}
                  options={["Latest", "Oldest"]}
                  // defaultValue="Latest"
                />
              </div>
            ) : (
              <div className={styles.create_project_btn}>
                <Button
                  variant={"filled"}
                  onClick={() => {
                    localStorage.removeItem("projectData");
                    navigate("/projects/create-project");
                  }}
                  className={styles.unhoverable}
                >
                  <PlusIconSVG height={19} width={19} />
                  <p>Create a project</p>
                </Button>
              </div>
            )}
          </div>
        </section>

        <section className={styles.projects_posts_section}>
          <div className={styles.projects_filter_div}>
            <ProjectsFilterSection
              pages={page}
              itemsPerPage={itemsPerPage}
              sortBy={sortBy}
              setSortBy={updateSortBy}
            />
          </div>
          <section id="scrollableSection" className={styles.project_section}>
            {isLoading && page === 1 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <ProjectCardSkeleton count={5} />
              </div>
            ) : projects?.length > 0 ? (
              <InfiniteScroll
                dataLength={projects.length}
                next={() => fetchProjects(false)}
                hasMore={hasMore}
                loader={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <ProjectCardSkeleton count={2} />
                  </div>
                }
                endMessage={<InfiniteEndMessage message="No more projects" />}
                className={styles.project_section}
              >
                {projects?.map((project, index) => (
                  <ProjectsCardComponent
                    page={page}
                    project={project}
                    key={index}
                  />
                ))}
              </InfiniteScroll>
            ) : (
              <div className={styles.no_jobs}>
                <img
                  src={noApplicationsImg}
                  alt=""
                  className={styles.noApplicationsImg}
                />
                <p className={styles.noApplications_text}>
                 No projects available
                </p>
              </div>
            )}
          </section>
        </section>

        {/* <section className={styles.pagination_section}>
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onInputChange={(e) => setPage(e.target.value)}
            onPageChange={(page) => setPage(page)}
          />
        </section> */}
      </section>
    </>
  );
};

export default ProjectsFeedPage;
